export default "__VITE_ASSET___s_JF9V0__"